import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * A wrapper component for routes that require authentication
 * Redirects to sign-in page if the user is not authenticated
 */
const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // Show loading state while auth state is being determined
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#F6E8E0]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated
  if (!currentUser) {
    return <Navigate to="/sign-in" state={{ from: window.location.pathname }} />;
  }

  // Render the protected route content if authenticated
  return children;
};

export default PrivateRoute;
